// extracted by mini-css-extract-plugin
export default {"preview":"PDFPreview_preview__jnYMr","code-snippet":"PDFPreview_code-snippet__6ihSW","image-preview":"PDFPreview_image-preview__FFBMR"};